// extracted by mini-css-extract-plugin
export var pickerModal = "_fr-0";
export var xButton = "_fr-1";